import React, { useState } from 'react';
import { FaMapMarkerAlt, FaUser, FaClock } from 'react-icons/fa';
import MediaGallery from '../../components/media/MediaGallery';
import Avatar from '../../components/notes/Avatar';
import DOMPurify from 'dompurify';
import TimeAgo from '../../components/timeAgo/TimeAgo';

const PostDetailCard = ({
  creatorName,
  description,
  createdOn,
  state,
  city,
  images = [],
  videos = [],
  attachments = [],
  service,
  photo, 
}) => {
  const [showFullDescription, setShowFullDescription] = useState(false);
  const descriptionWords = description?.trim().split(' ') || [];
  const isLongDescription = descriptionWords.length > 50;

  const displayedDescription =
    isLongDescription && !showFullDescription
      ? descriptionWords.slice(0, 50).join(' ') + '...'
      : description;

  return (
    <div className="card shadow px-4 pb-2 mb-5 bg-white rounded">

      {/* Media */}
      <MediaGallery
        images={images}
        promotion_videos={videos}
        attachments={attachments}
      />

      {/* Creator Info */}
      <div className="d-flex align-items-center mt-4">
        <Avatar src={photo} icon={creatorName} size={35} />
        <span className="text-muted ms-2">
          <strong>{creatorName}</strong>
        </span>
      </div>

      {/* Metadata */}
      <div className="mt-3">
        <div className="d-flex align-items-center text-muted mb-2">
          <FaClock className="me-2" />
          Created : <TimeAgo timestamp={createdOn} />
        </div>
        <div className="d-flex align-items-center text-muted">
          <FaMapMarkerAlt className="me-2" /> 
          {city}, {state}
        </div>
      </div>

      {/* Services Tags */}
      <div className="d-flex flex-wrap gap-3 fs-3 mt-4">
          <span className="badge bg-primary-subtle text-primary border">
            {service}
          </span>
      </div>

      {/* Description */}
      <div className="mt-4">
        <h5 className="text-muted">Description</h5>
        <div
          className="text-dark"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(displayedDescription),
          }}
        />
        {isLongDescription && (
          <button
            className="btn btn-link p-0 mt-2"
            onClick={() => setShowFullDescription(!showFullDescription)}
          >
            {showFullDescription ? 'Read Less' : 'Read More'}
          </button>
        )}
      </div>

    </div>
  );
};

export default PostDetailCard;
